<div class="file-upload-container">
  <ion-card class="profilebody ion-no-margin">
    <!-- header -->
    <ion-row class="header-row">
      <h3>{{ CONSTANTS.HEADER }}</h3>
      <img [src]="IMAGES.CLOSE" alt="close" (click)="closeFileUploadPopup()" />
    </ion-row>

    <!-- body -->
    <div
      class="file-upload-body"
      [ngClass]="{
        uploaded: [fileUploadStatus.SUCCESS, fileUploadStatus.FAILED].includes(
          uploadStatus
        ),
        'in-progress': uploadStatus === fileUploadStatus.IN_PROGRESS,
      }"
    >
      <p
        class="title"
        [hidden]="uploadStatus === fileUploadStatus.SUCCESS"
      >
        {{ CONSTANTS.NOTE }} <span class="csv">{{ CONSTANTS.CSV }}</span>
        {{ CONSTANTS.OR }} <span class="csv">{{ CONSTANTS.TXT }}</span>
      </p>
      <!--Commenting until server side changes are done  -->
      <p
        class="title"
        [hidden]="uploadStatus === fileUploadStatus.SUCCESS"
      >
        {{ CONSTANTS.TEMPLATE_TEXT }}
        <a
          [href]="templateFilePath"
          [attr.download]="templateDownloadName"
          (click)="downloadTemplate($event)"
          class="template-link"
          ><img [src]="templateIconUrl" alt="template icon"
        /></a>
      </p>
      <div class="dropzone" appDnd (fileDropped)="onFileDropped($event)">
        <input
          type="file"
          name=""
          id="fileDropRef"
          #fileDropRef
          (change)="fileBrowseHandler($event)"
          accept=".csv, .txt, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/plain"
        />
        @if (!file.fileItem) {
          <ion-icon src="assets/note_add.svg" class="add-icon"></ion-icon>
          <h3 class="file-drop-title">{{ CONSTANTS.DRAG_FILE }}</h3>
          <div class="or-wrapper">
            <hr class="line" />
            <p class="text">{{ CONSTANTS.OR }}</p>
            <hr class="line" />
          </div>
          <ion-row class="custom-row ion-justify-content-center">
            <ion-button fill="block" class="upload-btn">
              {{ CONSTANTS.BROWSE_FILES }}
            </ion-button>
          </ion-row>
        }
        @if (file.fileItem) {
          <div class="file-container">
            <ion-icon src="assets/file.svg" class="csv-file-icon"></ion-icon>
            <p class="file-name">{{ file.fileItem.name }}</p>
          </div>
        }
        @if (uploadStatus === fileUploadStatus.FAILED) {
          <div class="file-upload-error">
            <p class="message">{{ CONSTANTS.ERROR_MESSAGE }}</p>
          </div>
        }
      </div>
    </div>

    <!-- progress bar -->
    @if (file.fileItem) {
      <div class="progress-bar-container">
        @if (uploadStatus === fileUploadStatus.IN_PROGRESS) {
          <div class="file-status">
            {{ CONSTANTS.LOADING }} {{ file.fileItem.name }}...
          </div>
        }
        @if (uploadStatus === fileUploadStatus.SUCCESS) {
          <div class="file-status">
            {{ CONSTANTS.UPLOADED }} {{ file.fileItem.name }}
          </div>
        }
        @if (uploadStatus === fileUploadStatus.FAILED) {
          <div class="file-status">
            {{ CONSTANTS.UNABLE_UPLOAD }} {{ file.fileItem.name }}
          </div>
        }
        <app-progress-bar
          [progress]="file.progress"
          [status]="uploadStatus"
        ></app-progress-bar>
      </div>
    }

    <!-- footer -->
    @if (
      [fileUploadStatus.SUCCESS, fileUploadStatus.FAILED].includes(uploadStatus)
    ) {
      <ion-row class="footer-row ion-justify-content-between">
        <ion-button fill="outline" class="cancel-btn" (click)="cancel()">{{
          CONSTANTS.CANCEL
        }}</ion-button>
        @if (uploadStatus === fileUploadStatus.SUCCESS) {
          <ion-button
            fill="fill"
            class="submit-btn"
            (click)="uploadDocument(file)"
            >{{ CONSTANTS.SUBMIT }}</ion-button
          >
        }
        @if (uploadStatus === fileUploadStatus.FAILED) {
          <ion-button
            fill="fill"
            class="submit-btn reupload-btn"
            (click)="tryAgain = true"
          >
            {{ tryAgain ? CONSTANTS.REUPLOAD : CONSTANTS.TRY_AGAIN }}
          </ion-button>
        }
      </ion-row>
    }
  </ion-card>
</div>
